 import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Navbar, Container, Nav, Offcanvas, NavDropdown, Badge } from 'react-bootstrap';

import '../../interfaceSettings.css';
import GwinnettLogo from '../../assets/webp/ggc-light-logo.webp';
import { logout } from '../../actions/auth';

const AdminNavbar = () => {

    // State to handle mobile menu visibility 
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // TODO: Inspect & describe code behavior, I believe some of these are generic React functions
    const dispatch = useDispatch();

    // Function that handles logouts
    const handleLogout = () => {
        dispatch(logout());
    };

    const handleDropdownClick = (e) => {
        e.stopPropagation(); 
    };

    // HTML/JSX web page
    // TODO: Redesign page with necessary links for admininstration portals with front end for video handler/statistics viewer REST APIs
    return (
        <Navbar expand="lg" className="navbar-custom mb-3">
            <Container fluid>
                <Navbar.Brand as={Link} to="/adminHome" className="d-flex align-items-center">
                    <img src={GwinnettLogo} alt="Gwinnett Logo" className="logo me-2" />
                    <span className="heading-gradient">WALKING TRAILS</span>
                </Navbar.Brand>

                <div className="d-none d-lg-flex align-items-center me-3">
                    <Badge bg="primary" style={{ fontSize: '0.75rem' }}>
                        Role: Admin
                    </Badge>
                </div>

                {/* Mobile Menu Toggle Button */}
                <Navbar.Toggle
                    aria-controls="offcanvas-navbar"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className="d-lg-none"
                />

                {/* Offcanvas for Mobile */}
                <Navbar.Offcanvas
                    id="offcanvas-navbar"
                    placement="end"
                    show={isMenuOpen}
                    onHide={() => setIsMenuOpen(false)}
                    className="d-lg-none"
                >
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title>Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <Nav className="justify-content-end flex-grow-1 pe-3">
                            <Nav.Link as={Link} to="/userHome" onClick={() => setIsMenuOpen(false)}>
                                Home
                            </Nav.Link>
                            <Nav.Link as={Link} to="/trails" onClick={() => setIsMenuOpen(false)}>
                                Trails
                            </Nav.Link>

                            {/* Dropdown for Exercises on Mobile */}
                            <NavDropdown
                                title="Videos"
                                id="offcanvas-exercises"
                                onClick={handleDropdownClick}  // Prevent the offcanvas from closing
                            >
                                <NavDropdown.Item as={Link} to="/bodyWeightExercises" onClick={() => setIsMenuOpen(false)}>Body Weight Exercises</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/properWalkingTechniques" onClick={() => setIsMenuOpen(false)}>Proper Walking Techniques</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/stretchesForWalking" onClick={() => setIsMenuOpen(false)}>Stretches For Walking</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/nutritionandHydration" onClick={() => setIsMenuOpen(false)}>Nutrition and Hydration</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/injuryPrevention" onClick={() => setIsMenuOpen(false)}>Injury Prevention</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link as={Link} to="/adminHome" onClick={() => setIsMenuOpen(false)}>
                                Admin Dashboard
                            </Nav.Link>

                            <Nav.Link as={Link} to="/userControlPanel" onClick={() => setIsMenuOpen(false)}>
                                My Profile
                            </Nav.Link>
                            <Nav.Link onClick={handleLogout}>
                                Logout
                            </Nav.Link>
                        </Nav>

                            {/* MOBILE BADGE — place outside of Nav */}
                            <div className="mt-4 pt-3 d-lg-none" style={{ borderTop: '1px solid #dee2e6' }}>
                                <div className="d-flex justify-content-center">
                                    <Badge bg="primary" style={{ fontSize: '1rem', padding: '8px 16px' }}>
                                        Role: Admin
                                    </Badge>
                                </div>
                            </div>
                    </Offcanvas.Body>
                </Navbar.Offcanvas>

                {/* Desktop Links (Inline) */}
                <Navbar.Collapse id="navbarNav" className="d-none d-lg-flex">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/userHome">Home</Nav.Link>
                        <Nav.Link as={Link} to="/trails" onClick={() => setIsMenuOpen(false)}>
                            Trails
                        </Nav.Link>

                        {/* Dropdown for Exercises on Desktop */}
                        <NavDropdown title="Videos" id="navbar-exercises">
                            <NavDropdown.Item as={Link} to="/bodyWeightExercises">Body Weight Exercises</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/properWalkingTechniques">Proper Walking Techniques</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/stretchesForWalking">Stretches For Walking</NavDropdown.Item>                            
                            <NavDropdown.Item as={Link} to="/nutritionandHydration">Nutrition and Hydration</NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/injuryPrevention">Injury Prevention</NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link as={Link} to="/adminHome">Admin Dashboard</Nav.Link>
                        <Nav.Link as={Link} to="/userControlPanel">My Profile</Nav.Link>
                        <Nav.Link onClick={handleLogout}>
                            Logout
                        </Nav.Link>

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AdminNavbar;


